import {
  BatchSchoolStatisticsConditionListItem,
  BatchSchoolStatisticsConditionListItemFromJSON
} from './BatchSchoolStatisticsConditionListItem'

export interface BatchSchoolStatisticsGetPredefinedSettingResult {
  items: BatchSchoolStatisticsConditionListItem
}

export function BatchSchoolStatisticsGetPredefinedSettingResultFromJSON(
  json: any
): BatchSchoolStatisticsGetPredefinedSettingResult {
  return {
    items: BatchSchoolStatisticsConditionListItemFromJSON(json)
  }
}
